module.exports = __webpack_public_path__ + "img/id-menu-3.5b7ef38e.svg";